const logisticStatus = {
    'TITLE': 'Status Mapping',
}

export default logisticStatus;